import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery,
} from '@mui/material/'
import CloseIcon from '@mui/icons-material/Close'
import { ReactNode } from 'react'
import theme from 'lib/theme'

// if showButton is false, don't require other types related to button
// if showButton is true, all the button types are required

type ButtonProps =
  | {
      showButton: true
      buttonText: string
      buttonIsDisabled: boolean
      subtitle?: string
      isLoadingRequest: boolean
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onButtonClick: (() => Promise<void>) & (() => Promise<any>)
      buttonVariant?: 'contained' | 'alert' | 'text' | 'outlined'
    }
  | {
      showButton: false
      buttonText?: never
      buttonIsDisabled?: never
      subtitle?: never
      isLoadingRequest?: never
      onButtonClick?: never
      buttonVariant?: never
    }

type BasicProps = {
  modal: { right: boolean }
  setModal: () => void
  children: ReactNode
  title: string
}

type ModalProps = ButtonProps & BasicProps

const Modal = ({
  modal,
  setModal,
  children,
  title,
  subtitle,
  buttonText,
  isLoadingRequest,
  buttonIsDisabled,
  onButtonClick,
  showButton = true,
  buttonVariant = 'contained',
}: ModalProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Drawer
      anchor='right'
      open={modal.right}
      onClose={setModal}
      PaperProps={{
        sx: {
          width: '480px',
          padding: 0,
          [theme.breakpoints.between('xs', 'sm')]: {
            width: '100vw',
          },
        },
      }}>
      <Box
        sx={{
          mb: '50px',
          width: '480px',
          [theme.breakpoints.between('xs', 'sm')]: {
            width: '100vw',
          },
        }}
        display='flex'
        flexDirection='column'
        p={2}>
        <Box
          sx={{
            width: '460px',
            [theme.breakpoints.between('xs', 'sm')]: {
              width: 'calc(100vw - 20px)',
            },
          }}
          bgcolor='white'
          zIndex={10}
          display='flex'
          position='sticky'
          top='0'
          justifyContent='space-between'
          alignItems='center'
          mb={4}>
          <Typography
            variant='h2'
            sx={{
              fontWeight: 'bold',
            }}>
            {title}
          </Typography>
          <IconButton onClick={setModal}>
            <CloseIcon />
          </IconButton>
        </Box>
        {subtitle && (
          <Typography variant='body1' mb={4}>
            {subtitle}
          </Typography>
        )}
        {children}
        {showButton ? (
          <Button
            onClick={onButtonClick}
            disabled={isLoadingRequest || buttonIsDisabled}
            type='submit'
            variant={buttonVariant}
            sx={{
              width: isMobile ? '92%' : '450px',
              position: 'fixed',
              bottom: '17px',
            }}>
            {isLoadingRequest ? (
              <CircularProgress
                size='20px'
                sx={{
                  color: theme.palette.commonColors.white,
                }}
              />
            ) : (
              buttonText
            )}
          </Button>
        ) : null}
      </Box>
    </Drawer>
  )
}

export default Modal
